import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=5b6115cf"
import script from "./Medias.vue?vue&type=script&lang=js"
export * from "./Medias.vue?vue&type=script&lang=js"
import style0 from "./Medias.vue?vue&type=style&index=0&id=5b6115cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports